import(/* webpackMode: "eager" */ "/vercel/path0/src/app/admin-dashboard/page.tsx");
